<picture [attr.aspect-ratio]="currentVariant.aspectRatio">
  @for (variant of variants; track variant.aspectRatio) {
    <source [srcset]="picture[variant.aspectRatio] !== undefined ? toSrcsetString(picture[variant.aspectRatio]!) : ('missing picture variant ' + variant.aspectRatio)" [attr.media]="variant.mediaQuery" [attr.sizes]="sizes">
  }
  <img [attr.loading]="aboveFold ? null : 'lazy'" [attr.fetchpriority]="aboveFold ? 'high' : null" [src]="fallbackSource" [alt]="alt" [attr.draggable]="draggable">
</picture>
